import { postApi } from "./api";

export const createShipment = async (orderData) => {
    try {
        const response = await postApi(
            "/Shipment/Generate",
            orderData
        );
        return response;

    } catch (error) {
        console(error);
        throw error.response?.data || error.message;
    }
};
export const cancelShipment = async (canceleData) => {
  try {
    const response = await postApi(
      "/Shipment/Cancelled",
      canceleData
    );
    return response;
  } catch (error) {
    console.error(
      "Error:",
      error.response?.data || error.message
    );
  }
};
export const GenerateLabel = async (request) => {
    const response = await postApi(
        "/Shipment/GenerateLabel",
        request,
        {
            responseType: "blob",
        }
    );

    return response.data;
};
export const GenerateManifest = async (payload) => {
    return await postApi(
        "/Shipment/GenerateMenifest",
        payload
    );
};